import React, { useEffect, useState } from 'react'
import { Page, View, Document as Doc, StyleSheet, PDFViewer } from '@react-pdf/renderer'
import TableHeader from './Table/header'
import TableRow from './Table/row'
import TableBanner from './Table/banner'
import { Users } from '../../../Types/Users'

const RelatorioUsuarioTecnicoPdf: React.FC = () => {

    const [usuarios, setUsuarioTecnico] = useState<Users[] | null>(null)

    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#E4E4E4'
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        }
    })

    useEffect(() => {
        (async() => { setUsuarioTecnico(JSON.parse(localStorage.getItem('Usuario')!)) })()
    }, [])

    return(

        <>
            {!!usuarios && (
                <PDFViewer style={{ width: '100vw', height: '100vh' }}>
                    <Doc>
                        <Page size="A4" style={styles.page} break>
                            <View style={styles.section}>
                                <TableBanner />
                                <TableHeader />
                                {usuarios.map((item, index) => <TableRow key = {index} {...item} />)}
                            </View>
                        </Page>
                    </Doc>
                </PDFViewer>
            )}
        </>

    )

}

export default RelatorioUsuarioTecnicoPdf